import { render, staticRenderFns } from "./CustomerSaleHistoryModal.vue?vue&type=template&id=a65f09e6&scoped=true&"
import script from "./CustomerSaleHistoryModal.vue?vue&type=script&lang=js&"
export * from "./CustomerSaleHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65f09e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65f09e6')) {
      api.createRecord('a65f09e6', component.options)
    } else {
      api.reload('a65f09e6', component.options)
    }
    module.hot.accept("./CustomerSaleHistoryModal.vue?vue&type=template&id=a65f09e6&scoped=true&", function () {
      api.rerender('a65f09e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/components/CustomerSaleHistoryModal.vue"
export default component.exports